import { getDie } from './dice';
import './DieMiniature.css';

const DieMiniature = ({
  dieId,
  faceValues,
  rotating = false,
  className = '',
}) => {
  const die = getDie(dieId);
  const faces =
    faceValues?.length === 6 ? faceValues : die.faces || Array(6).fill('?');

  return (
    <span
      className={`coreboundDieMiniature ${
        rotating ? 'is-rotating' : ''
      } ${className}`}
      data-die={die.id}
      style={{ '--die-color': die.color, '--die-body': die.body }}
      aria-hidden="true"
    >
      <span className="coreboundDieMiniCube">
        {faces.map((face, index) => (
          <span className="coreboundDieMiniFace" key={index}>
            <span>{face}</span>
          </span>
        ))}
      </span>
    </span>
  );
};

export default DieMiniature;
